module.exports = __webpack_public_path__ + "media/images/nita_online_payment_steps/1-6c12477a017867407369107c8abfd7ee.png";